<div class="orders py-4 shippingmethodpicklist">
  <header class="orders-header has-border align-items-center d-flex pb-2 mb-4">
    <h1 class="m-0 col-3">Footer Templates</h1>
    <jni-spinner *ngIf="showSmallLoader"></jni-spinner>
    <h1 class="col-9 text-center">
      <span>
        {{ selectedPickListItem?.name }}
      </span>
    </h1>
  </header>
  <form>
    <div class="row">
      <div class="col-3">
        <p-listbox
          [options]="templatesPickList"
          optionLabel="name"
          [filter]="true"
          (onClick)="getClickedTemplate($event)"
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="selectedPickListItem">
        </p-listbox>
      </div>

      <div class="col-9">
        <p-editor
          id="email-editor"
          [style]="{ height: '398px' }"
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="editorText">
        </p-editor>
      </div>
    </div>

    <div class="d-flex py-3 has-sticky justify-content-end">
      <button
        class="btn btn-primary"
        [disabled]="selectedPickListItem?.id === 0"
        type="submit"
        (click)="reportFooterUpdate()">
        Save
      </button>
    </div>
  </form>
</div>
